module.exports = __webpack_public_path__ + "img/product-type-wrap-bg.6d629001.png";